import { theme } from "@project/shared/src/theme";
import { styled } from "linaria/react";
const Wrapper = /*#__PURE__*/styled("section")({
  name: "Wrapper",
  class: "wwygx8y"
});
const Overlay = /*#__PURE__*/styled("div")({
  name: "Overlay",
  class: "o1ftmjqr"
});
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "cfqub0s"
});
interface Props {
  info: string;
  title?: string;
}

const ContactBanner = ({
  info,
  title
}: Props) => {
  return <Wrapper>
      <Container>
        <div>
          <h1 className="banner-title">{title ? title : "CONTACT"}</h1>
          <p>{info}</p>
        </div>
      </Container>

      <Overlay>
        <img src="/contact-banner.svg" />
      </Overlay>
    </Wrapper>;
};

export { ContactBanner };

require("./index.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");